<template>
    <section>
        <div class="container connect">
            <div class="connect__head">
                <h2 class="connect__header heading-secondary">
                    {{ title }}
                </h2>
                <p
                    class="connect__header-title"
                    v-html="text"
                ></p>
            </div>
            <div
                v-if="videoPlayer"
                class="connect__video-container"
            >
                <VideoPlayer
                    :link="videoPlayer.src"
                    :isOnlyPreview="true"
                    :preview="videoPlayer.preview"
                    :alt="videoPlayer.alt"
                    theme="rounded"
                />
            </div>

            <div
                v-if="isSlotUsed"
                class="connect__steps-new"
            >
                <div class="connect__steps-new-item">
                    <p>
                        <slot name="step1"></slot>
                    </p>
                </div>
                <div class="connect__steps-new-item">
                    <p>
                        <slot name="step2"></slot>
                    </p>
                </div>
                <div class="connect__steps-new-item">
                    <p>
                        <slot name="step3"></slot>
                    </p>
                </div>
            </div>

            <div
                v-if="steps && !isSlotUsed"
                class="connect__steps-new"
            >
                <div class="connect__steps-new-item">
                    <p v-html="steps[0]"></p>
                </div>
                <div class="connect__steps-new-item">
                    <p v-html="steps[1]"></p>
                </div>
                <div class="connect__steps-new-item">
                    <p v-html="steps[2]"></p>
                </div>
            </div>

            <p
                v-if="isSlotUsed"
                class="connect__p"
            >
                <slot name="text"></slot>
            </p>
            <p
                v-else
                class="connect__p"
                v-html="text"
            ></p>
            <p
                v-if="secondParagraph"
                class="connect__p-second"
                v-html="secondParagraph"
            ></p>
        </div>
    </section>
</template>
<script>
import VideoPlayer from '../VideoPlayer';

export default {
    name: 'HowConnectStep2',
    components: {
        VideoPlayer,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        isSlotUsed: {
            type: Boolean,
            default: false,
        },
        steps: {
            type: Array,
            default: null,
        },
        secondParagraph: {
            type: String,
            default: '',
        },
        videoPlayer: {
            type: Object,
            default: null,
        },
    },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
